export const simpleDateFormatter = (
    dateString: string, 
    dateFormat?: object | undefined 
) => {
    const date: Date = new Date(dateString);
    const defaultDateFormat = {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    };
    const formattedDate = date.toLocaleDateString(
        'en-US', 
        dateFormat || defaultDateFormat
    ).replace(/\//g, '-');

    return formattedDate;
}

export const lastUpdateFormatter = (dateString: string) => {
    const date = new Date(dateString);
    
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const month = months[date.getUTCMonth()];
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    
    return `${day} ${month}, ${year} | ${hours}:${minutes}`;
  }

export const publishedTimeFormatter = (dateString: string) => {
    const date: Date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
}
